import { Stack,Link,Typography } from "@mui/material";
import { useLocation} from "react-router-dom";
import './EmailSent.scss';
import { useNavigate } from 'react-router-dom';
export default function EmailSent() {
    const location = useLocation();
    const email = location.state?.userEmail || "your email"; // default email if not provided
    const header = location.state?.header || "Email Sent!"; // default header if not provided
    const navigate = useNavigate();
    return (
        <div className="reset-success-page" data-testid="reset-success-page">
            <div className="reset-success-wrapper" data-testid="reset-success-wrapper">
                <div className="form-container" data-testid="form-container">
                    <Stack
                        spacing={2}
                        data-testid="reset-success-stack"
                        sx={{ width: "100%" }}
                >
                    <h1 className="WelcomeHeader" data-testid="welcome-header">{header}</h1>
                    <p className="ResetInstructions" data-testid="reset-instructions">If an account with this email: <u data-testid="email-display">{email}</u> exists, <br/> an email has been sent. <br></br><br></br>The email may take a few minutes to arrive in your inbox.
                    </p>
                   <Typography 
                    className="ContactSupport" 
                    variant="body1"
                    sx={{ whiteSpace: 'nowrap', display: 'inline-block' }}
                    >
                    For Issues, Contact Support: <a data-testid="contact-support" href="mailto:support@accesspointprogram.org?subject=Trouble Resetting Password&body=Hello support team," className="email">support@accesspointprogram.org</a>
                    </Typography>
                    <h3 className="accountHeader" data-testid="account-header">Return to <Link href="/Login" data-testid="login-link">Login</Link></h3>
                </Stack>
                </div>
                
            </div>
        </div>
    )
}